<template>
  <div>
    <deal-form
      v-if="showDealForm"
      :deal-id="dealId"
      :is-read-only="isReadOnly"
      :modal-visible="showDealForm"
      :isDialog="false"
      @close="close"
      :dealTypeId="dealTypeId"
    />
    <div v-if="showExposureDrillDown">
      <otc-exposure-drilldown
        :reportParameters="reportParameters"
        :is-read-only="isReadOnly"
        v-model="show"
        :read-url="readUrl"
        :export-url="exportUrl"
        :component="component"
      >
        <kendo-button
          icon="add"
          title="Create deal"
          v-if="!isReadOnly"
          @click="openDealForm(0)"
        ></kendo-button>
      </otc-exposure-drilldown>
    </div>
  </div>
</template>

<script>
import DealForm from '../../views/List/Deal/DealForm'
import OtcExposureDrilldown from '../../components/Report/OtcExposureDrilldown'

export default {
  props: {
    value: {
      type: Boolean,
    },
    reportParameters: {
      type: Object,
    },
    isReadOnly: {type: Boolean, default: true},
    readUrl: {type: String, default: '/api/report/ExposureReport/drilldown'},
    exportUrl: {type: String, default: '/api/report/ExposureReport/exportDrilldown'},
    component: {type: String, default: 'vonap-window'},
  },
  mounted() {
    document.body.addEventListener('click', this.dealLinkClick, false)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.dealLinkClick)
  },
  data() {
    return {
      showDealForm: false,
      showExposureDrillDown: true,
    }
  },
  methods: {
    openDealForm(dealId) {
      this.showExposureDrillDown = false
      this.dealId = dealId
      this.showDealForm = true
    },
    dealLinkClick({target}) {
      if (!/dealCodeLink/.test(target.className)) return
      const dealId = target.dataset.dealid
      this.openDealForm(dealId)
    },
    close() {
      this.showExposureDrillDown = true
      this.showDealForm = false
    },
  },
  computed: {
    dealTypeId() {
      // TODO: See how to handle the deal type, probably won't be needed
      return 1
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  components: {
    DealForm,
    OtcExposureDrilldown,
  },
}
</script>
